import { Navigate, useSearchParams } from "react-router-dom";
import { ReactNode } from "react";

/**
 * Bare /workflows visit (no query params) redirects to Governance.
 * Any query params (workflow=, filter=, tab=, wid=, gh_prefill=, id=, launched=)
 * keep the Workflow Library rendering exactly as before.
 */
export function WorkflowsRoute({ children }: { children: ReactNode }) {
  const [searchParams] = useSearchParams();
  if ([...searchParams.keys()].length === 0) {
    return <Navigate to="/governance" replace />;
  }
  return <>{children}</>;
}
